import { getSharedAuthCookieDomain } from './siteHosts';

export const AUTH_STORAGE_KEY = 'lewouhmart_auth';
export const AUTH_COOKIE_NAME = 'lewouhmart_auth';
const AUTH_COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 30;

function readCookie(name: string): string | null {
  const pattern = new RegExp(`(?:^|; )${name}=([^;]*)`);
  const match = document.cookie.match(pattern);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}

export function readPersistedAuthRaw(): string | null {
  try {
    const fromLocal = window.localStorage.getItem(AUTH_STORAGE_KEY);
    if (fromLocal) return fromLocal;
  } catch {
    // ignore
  }
  return readCookie(AUTH_COOKIE_NAME);
}

export function persistAuthRaw(json: string): void {
  try {
    window.localStorage.setItem(AUTH_STORAGE_KEY, json);
  } catch {
    // ignore
  }

  const domain = getSharedAuthCookieDomain();
  if (!domain) return;

  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = [
    `${AUTH_COOKIE_NAME}=${encodeURIComponent(json)}`,
    `Domain=${domain}`,
    'Path=/',
    `Max-Age=${AUTH_COOKIE_MAX_AGE_SEC}`,
    'SameSite=Lax',
    secure,
  ].join('; ');
}

export function clearPersistedAuth(): void {
  try {
    window.localStorage.removeItem(AUTH_STORAGE_KEY);
  } catch {
    // ignore
  }

  const domain = getSharedAuthCookieDomain();
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  const base = `${AUTH_COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
  document.cookie = base;
  if (domain) {
    document.cookie = `${base}; Domain=${domain}`;
  }
}
